// extracted by mini-css-extract-plugin
export default {"CollapsibleTextGroup":"jnbU2thGNFOFlv8DYPjq","CollapsibleTextGroup__title":"UjSUMc4XZmeg1WEbDnJ_","CollapsibleTextGroup__content":"oHdEsIk3PqFhBSWVq9Yp"};